export default __webpack_public_path__ + "static/media/fire-protection.b0df0f15.jpg";